import { useNavigate, useLocation } from "react-router-dom";

const BackButton = ({ newLocation = "", depth = -1 }) => {
  const navigate = useNavigate();
  const location = useLocation();
  console.log("New Location:", newLocation);
  const goBackOneLevel = () => {
    // Check if the newLocation prop is provided and navigate to it if so
    if (newLocation.length > 0) {
      navigate(newLocation);
      return;
    }
    console.log("Back button clicked, navigating back.");

    // Navigate up the URL tree by keeping only the specified number of segments
    const pathSegments = location.pathname
      .split("/")
      .filter((segment) => segment !== "");
    const segmentsToKeep = Math.min(depth, pathSegments.length);
    const newPath = "/" + pathSegments.slice(0, segmentsToKeep).join("/");

    console.log("Navigating to ancestor path:", newPath);
    navigate(newPath);
  };

  return (
    <button
      className="py-3 px-6 border bg-black sm:w-auto"
      onClick={goBackOneLevel}
    >
      Back
    </button>
  );
};

export default BackButton;
